module.exports = __webpack_public_path__ + "static/media/RKE_CIAPKA.2c416d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RKE_CIAPKA.png
// module id = 697
// module chunks = 0